import { Flex } from "@chakra-ui/react";
import { isNil } from "lodash/fp";

import { Toggle } from "design_system/components/Toggle";
import { StripePriceType } from "graphql/generated";

interface Props {
  onToggle?: (any) => void;
  isSubscriptionPrice?: () => void;
  price?: { type: string };
}

const PriceSwitch = ({ onToggle, ...props }: Props) => {
  const {
    isSubscriptionPrice: canToggle,
    price: { type }
  } = props;
  const hasToggle = !isNil(canToggle);

  const isSubscriptionPrice = type === StripePriceType.Recurring;

  return (
    <Flex margin="1px" opacity={isSubscriptionPrice ? 1 : 0.4} alignItems="center">
      {hasToggle && <Toggle isChecked={isSubscriptionPrice} onChange={onToggle} size="small" />}
    </Flex>
  );
};
export default PriceSwitch;
